import React from 'react'

import {useProductList} from '../util/product-list-context'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

const ProductListFamily = () => {
    const {category} = useProductList()

    return <Box as="section">@TODO: create family PLP</Box>
}

ProductListFamily.propTypes = {}

export default ProductListFamily
